/**
 * @Author maogangfeng
 * @Date 2020-03-26 09:07:38
 * @Desc 绘图工具
 */
export default class DrawPen {
  constructor(elm, backgroundImage) {
    this.drawColor = '#66ffcc'
    this.drawWay = 'rect'
    this.elm = elm
    this.ctx = null
    this.canvasWidth = 0
    this.canvasHeight = 0
    this.backgroundImage = backgroundImage
    this.hasSavedFeature = []
    this.startX = ''
    this.startY = ''
    this.drawFunction = {
      rect: this.drawRect.bind(this),
      circle: this.drawCricle.bind(this)
    }
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:37:54
   * @Desc 设置stroke颜色
   */
  setColor(color) {
    this.drawColor = color
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:37:56
   * @Desc 设置绘制图形
   */
  setDrawWay(drawWay) {
    this.drawWay = drawWay
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:37:58
   * @Desc 设置canvas对象
   */
  setElement(elm) {
    this.elm = elm
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-27 20:47:43
   * @Desc 设置背景图
   */
  setBackgroundImage(img) {
    this.backgroundImage = img
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:38:00
   * @Desc 绘制圆
   */
  drawCricle(startX, startY, lastX, lastY, color) {
    this.ctx.beginPath()
    this.ctx.strokeStyle = color
    const radius = Math.sqrt(Math.pow(lastX - startX, 2) + Math.pow(lastY - startY, 2))
    this.ctx.arc(startX, startY, radius, 0, 2 * Math.PI)
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:38:03
   * @Desc 绘制矩形
   */
  drawRect(startX, startY, lastX, lastY, color) {
    this.ctx.beginPath()
    this.ctx.strokeStyle = color
    this.ctx.strokeRect(startX, startY, lastX - startX, lastY - startY)
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:38:05
   * @Desc 刷新背景图像
   */
  refreshImage() {
    this.ctx.drawImage(this.backgroundImage, 0, 0, this.canvasWidth, this.canvasHeight)
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:38:07
   * @Desc 清除画布
   */
  clearCanvas() {
    this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
  }
  resetFeature() {
    this.hasSavedFeature = []
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:38:09
   * @Desc 绘制函数
   */
  draw(startX, startY, lastX, lastY) {
    this.clearCanvas()
    this.refreshCanvas()
    // this.ctx.beginPath()
    this.drawFunction[this.drawWay](startX, startY, lastX, lastY, this.drawColor)
    // this.ctx.strokeStyle = this.drawColor // 用获取到的颜色作为绘制颜色
    this.ctx.stroke()
  }
  refreshCanvas() {
    this.backgroundImage && this.refreshImage()
    for (let index = 0; index < this.hasSavedFeature.length; index++) {
      const feature = this.hasSavedFeature[index]
      // this.ctx.moveTo(feature.startX, feature.startY)
      this.drawFunction[feature.type](
        feature.startX,
        feature.startY,
        feature.lastX,
        feature.lastY,
        feature.color
      )
      // this.ctx.strokeStyle = feature.color
      this.ctx.stroke()
    }
  }
  /**
   * @Author maogangfeng
   * @Date 2020-03-26 09:38:12
   * @Desc 初始化参数和方法
   */
  init() {
    if (this.elm) {
      this.ctx = this.elm.getContext('2d') // 图形上下文——绘图接口
      this.canvasWidth = this.elm.width
      this.canvasHeight = this.elm.height
      this.backgroundImage && this.refreshImage()
      this.elm.onmousedown = ev => {
        this.startX = ev.offsetX
        this.startY = ev.offsetY
        this.elm.onmousemove = event => {
          this.draw(this.startX, this.startY, event.offsetX, event.offsetY)
        }
        this.elm.onmouseup = eve => {
          this.hasSavedFeature.push({
            type: this.drawWay,
            startX: this.startX,
            startY: this.startY,
            lastX: eve.offsetX,
            lastY: eve.offsetY,
            color: this.drawColor
          })
          this.elm.onmousemove = null
          this.elm.onmouseup = null
        }
      }
    } else {
      throw new Error('Need canvasElement')
    }
  }
}
